import { DataBean } from "../../DataBean";


export class RelationshipType extends DataBean {

    public async getRelationshipTypeCatalog(args: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getRelationshipTypeCatalog_Number", [args]);
    }

}